import { render } from "./InstructorContactInfo.vue?vue&type=template&id=5af51d72&scoped=true"
import script from "./InstructorContactInfo.vue?vue&type=script&lang=js"
export * from "./InstructorContactInfo.vue?vue&type=script&lang=js"

import "./InstructorContactInfo.vue?vue&type=style&index=0&id=5af51d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af51d72"]])

export default __exports__